import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProductName, ReleaseIssue, ReleaseIssueCategory, ReleaseIssuePriority, ReleaseIssueStatus } from 'situview-webapi-client';
import { QuickViewDialogComponent } from 'src/app/components';

@Component({
  selector: 'release-issue-card',
  templateUrl: './release-issue-card.component.html',
  styleUrls: ['./release-issue-card.component.scss']
})
export class ReleaseIssueCardComponent {
  @Input() item: ReleaseIssue | undefined;
  @Input() companyId: string | undefined;
  @Input() searchTerm: string | undefined;
  @Input() hideEdit: boolean = false;
  @Input() isSelectable: boolean = false;
  @Input() selectedCard: string | undefined;
  @Input() productName: ProductName | undefined;
  @Output() onEdit: EventEmitter<string> = new EventEmitter();
  @Output() onSelectClick: EventEmitter<string> = new EventEmitter();
  @Output() onPriorityClick: EventEmitter<ReleaseIssuePriority> = new EventEmitter();
  @Output() onStatusClick: EventEmitter<ReleaseIssueStatus> = new EventEmitter();
  @Output() onCreatedClick: EventEmitter<string> = new EventEmitter();
  @Output() onAssignedClick: EventEmitter<string> = new EventEmitter();
  @Output() onIssueLoadClick: EventEmitter<string> = new EventEmitter();
  
  releaseIssuePriorities = ReleaseIssuePriority;
  releaseIssueStatuses = ReleaseIssueStatus;
  releaseIssueCategories = ReleaseIssueCategory;

  constructor(private dialog: MatDialog) { }

  dialogRef!: MatDialogRef<QuickViewDialogComponent>;

  getPriority(releaseIssuePriority: ReleaseIssuePriority) {
    switch(releaseIssuePriority) {
      case ReleaseIssuePriority.High:
        return "Blocker";
      case ReleaseIssuePriority.Medium:
        return "Medium";
      default: 
        return "Low";
    }
  }

  edit() {
    if (this.item?.id) {
      this.onEdit.emit(this.item.id);
    }
  }

  select() {
    if (this.item?.id) {
      this.onSelectClick.emit(this.item.id);
    }
  }

  openSituLink() {
    if (this.item?.reportedSituLink) {
      this.dialog.open(QuickViewDialogComponent, {
            width: '95%',
            height: '95%',
            disableClose: true,
            data: { 
              quickViewProductName: this.item.productName === ProductName.Facade ? ProductName.Facade : ProductName.Panorama,
              quickViewLink: this.item?.reportedSituLink,
              showHistory: true,
              title: this.item?.title,
              companyId: this.companyId,
              releaseIssueId: this.item?.id
            }
          });
    }
  }

  filterByPriority(releaseIssuePriority: ReleaseIssuePriority | undefined) {
    this.onPriorityClick.emit(releaseIssuePriority);
  }
  
  filterByStatus(releaseIssueStatus: ReleaseIssueStatus | undefined) {
    this.onStatusClick.emit(releaseIssueStatus);
  }
  
  filterByCreated(created: string | undefined) {
    this.onCreatedClick.emit(created);
  }
  
  filterByAssigned(assigned: string | undefined) {
    this.onAssignedClick.emit(assigned);
  }

  loadIssueInViewer() {
    this.onIssueLoadClick.emit(this.item?.reportedSituLink);
  }
}